import { render, staticRenderFns } from "./Eliminar.vue?vue&type=template&id=38099eec&scoped=true&"
import script from "./Eliminar.vue?vue&type=script&lang=js&"
export * from "./Eliminar.vue?vue&type=script&lang=js&"
import style0 from "./Eliminar.vue?vue&type=style&index=0&id=38099eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38099eec",
  null
  
)

export default component.exports